import React, { FC } from 'react';
import { Badge, IconButton } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import isNumber from 'lodash/isNumber';

const useStyles = makeStyles(() => ({
  userNotificationsBtn: {
    padding: '12px',
    '& .MuiBadge-badge': {
      top: '2px',
      right: '2px',
      fontSize: (count: number | undefined) => {
        if (isNumber(count)) {
          if (count > 99) {
            return '7px';
          } else if (count > 9) {
            return '8.5px';
          }
        }

        return '10px';
      },
    },
  },
}));

interface IUserNotificationsBtn {
  onClick: (event: React.MouseEvent) => void;
  count?: number;
}

const UserNotificationsBtn: FC<IUserNotificationsBtn> = ({ onClick, count }) => {
  const classes = useStyles(count);
  const badgeContent = isNumber(count) && count > 99 ? '99+' : count;

  return (
    <IconButton
      onClick={onClick}
      className={classes.userNotificationsBtn}
      aria-label="notifications"
      color="secondary"
    >
      <Badge color="error" badgeContent={badgeContent || undefined}>
        <Notifications color="inherit" />
      </Badge>
    </IconButton>
  );
};

export default UserNotificationsBtn;
